import React from "react";
import { useNavigate } from "react-router-dom";

const LinkList = () => {
  const navigate = useNavigate();

  return (
    <ul className="button-list bg-white">
      <li className="mb-2">
        <button 
          onClick={() => navigate("/privacy-policy")} 
          className="fs_12 ff_inter button-link"
        >
          Privacy Policy
        </button>
      </li>
      <li className="mb-2">
        <button 
          onClick={() => navigate("/terms-and-conditions")} 
          className="fs_12 ff_inter button-link"
        >
          Terms and Conditions
        </button>
      </li>
      <li className="mb-2">
        <button 
          onClick={() => navigate("/return-policy")} 
          className="fs_12 ff_inter button-link"
        >
          Return Policy
        </button>
      </li>
      <li className="mb-2">
        <button 
          onClick={() => navigate("/shipping-policy")} 
          className="fs_12 ff_inter button-link"
        >
          Shipping Policy
        </button>
      </li>
    </ul>
  );
};

export default LinkList;
